export const formatTimestamp = (timestamp: number, language: string) => {
  const date = new Date(timestamp * 1000)

  const formattedDate =
    new Intl.DateTimeFormat(`${language}-ES`, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(date) + 'h'

  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
}
